var map = {
	"./berry-sparkle-sangria.png": "bfSm",
	"./paradise-paloma.png": "oCA3",
	"./sang-pal.png": "8ZwJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XgNN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sang-pal ^\.\/.*$
// module id = XgNN
// module chunks = 0